export default __webpack_public_path__ + "static/blob3-da7546ac9f4b046984f734385c0e716b.svg";